type UserOtherInformationCardProps = {
  userInfo: any;
  onValueChange: (field: string, value: any) => void;
};

export const UserOtherInformationCard = ({
  userInfo,
  onValueChange,
}: UserOtherInformationCardProps) => (
  <div>
    <h2 className="mt-10 mb-5 label-light-blue-xl">そのほか情報</h2>

    <textarea
      className="w-full text-lg text-black border border-gray-300 rounded-lg p-2 resize-y min-h-[2.5rem] max-h-[6rem] focus:outline-none focus:ring-2 focus:ring-blue-400"
      placeholder="メモを入力してください..."
      rows={2}
      onChange={(e) => onValueChange("notes", e.target.value)}
      value={userInfo?.notes || ""}
    />
  </div>
);
